import firebase from 'firebase';

const config = {
  apiKey: "AIzaSyA-lcJzTqcQ5D04_KFgBooaXs-FyT98dRw",
  authDomain: "mrsk-upu.firebaseapp.com",
  databaseURL: "https://mrsk-upu.firebaseio.com",
  projectId: "mrsk-upu",
  storageBucket: "mrsk-upu.appspot.com",
  messagingSenderId: "115128975448"
};
firebase.initializeApp(config);

export default firebase;
export const providerGM = new firebase.auth.GoogleAuthProvider();
export const providerFB = new firebase.auth.FacebookAuthProvider();
export const auth = firebase.auth();
export const storageRef = firebase.storage().ref();



// WEBPACK FOOTER //
// ./src/firebase.js